// Mock data for Newberry Wieters Law Firm website

export const FIRM = {
  name: "Newberry Wieters",
  fullName: "Newberry Wieters Law Firm",
  tagline: "We Understand How Both Sides Think.",
  logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_47ed3653-c238-41da-87d4-05308a7e4d49/artifacts/kp1x0pov_NewberryWieters_logoA_color_01.jpg",
  address: {
    street: "171 Church Street, Suite 150",
    city: "Charleston",
    state: "SC",
    zip: "29401",
  },
  phone: "843.998.7110",
  email: "info@nwlawsc.com",
  founded: 2024,
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1772692194403-7db6bce951b8";
export const ABOUT_BG_IMAGE =
  "https://images.pexels.com/photos/37129338/pexels-photo-37129338.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1920";
export const CONSTRUCTION_IMAGE =
  "https://images.pexels.com/photos/3818947/pexels-photo-3818947.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const CHARLESTON_IMAGE =
  "https://images.pexels.com/photos/26859630/pexels-photo-26859630.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const MEDIATION_IMAGE =
  "https://images.pexels.com/photos/33175650/pexels-photo-33175650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const FOUNDERS_IMAGE =
  "https://customer-assets-jai6qajn.emergentagent.net/job_newberry-wieters/artifacts/aqb7j9xk_LizDerekHeadshots-18%20cropped.webp";

export const STATS = [
  { value: "40+", label: "Years Combined Experience" },
  { value: "6", label: "Practice Areas" },
  { value: "$100M+", label: "Recovered for Clients" },
  { value: "1", label: "Charleston Office" },
];

export const PRACTICE_AREAS = [
  {
    slug: "construction-litigation",
    title: "Construction Litigation",
    short:
      "Representing owners, contractors, subcontractors, and design professionals in complex construction disputes.",
    long:
      "Construction litigation is at our core. Our attorneys have helped clients navigate construction litigation ranging in size and complexity, including routinely litigating defect and construction-related injury claims in which damages exceed $10,000,000. We have handled claims involving contractor negligence, design errors, and product defect claims, as well as claims arising from single family residential, multi-family residential, commercial property and civil infrastructure projects. Through this deep litigation experience, we also know the risk mitigation tools which help those involved in the construction space manage risk on the front-end through contract drafting, negotiation and pre-claim dispute resolution.",
  },
  {
    slug: "insurance-coverage-risk-transfer",
    title: "Insurance Coverage & Risk Transfer",
    short:
      "Counseling clients on additional insured status, indemnity, and effective risk-transfer strategies.",
    long:
      "We counsel clients on first-party and third-party coverage issues involving property, commercial, and liability claims, including risk transfer, additional insured status, indemnity, allocation, defense obligations, and other complex coverage questions. We partner closely with clients to evaluate coverage positions, resolve disputes, and develop efficient strategies aligned with their objectives. We represent insurers and policyholders across state and federal courts.",
  },
  {
    slug: "bad-faith-insurance-litigation",
    title: "Bad Faith Insurance Litigation",
    short:
      "Representing parties when insurance disputes escalate into actual or alleged bad faith claims.",
    long:
      "Sometimes insurance disputes deteriorate into actual or alleged bad faith insurance claims practices. When that occurs, our attorneys stand ready to assist in litigation from start to finish.",
  },
  {
    slug: "mediation",
    title: "Mediation",
    short:
      "Certified Circuit Court Mediation services helping parties resolve complex disputes efficiently.",
    long:
      "As a Certified Circuit Court Mediator, Derek serves as a neutral to help parties resolve complex disputes of all types. Focused on front-end preparation, creativity, and a commitment to continuing the process until all avenues for resolution are exhausted, Derek is available to mediate civil disputes of all varieties.",
  },
  {
    slug: "personal-injury-wrongful-death",
    title: "Personal Injury & Wrongful Death",
    short:
      "Advocating for individuals and families harmed by the negligence of others.",
    long:
      "Our attorneys have litigated personal injury and wrongful death disputes ranging in size, severity, and complexity. We rely upon experience, tenacity, and creativity, not bluster. From minor injuries to catastrophic, life-changing injuries and wrongful death claims, our attorneys have the knowledge and depth to guide you through the turmoil of such events.",
  },
  {
    slug: "professional-liability",
    title: "Professional Liability",
    short:
      "Handling professional liability matters involving architects, engineers, and other professionals.",
    long:
      "Our attorneys have litigated professional liability claims across a broad spectrum of professions, including professional malpractice claims involving architects, engineers, real estate agents, chiropractors, medical facilities, home health agencies, and paramedics. Whether the claim involves personal injury, death, property damage or financial loss, we have the depth of experience to guide you toward the result you desire.",
  },
  {
    slug: "corporate-counsel",
    title: "Corporate Counsel",
    short:
      "Proactive counsel for businesses on contracts, risk allocation, and commercial transactions.",
    long:
      "We work closely with businesses to identify legal risks before they become disputes. Our attorneys advise clients on structuring commercial relationships, negotiating and drafting contracts, allocating risk, and developing practical strategies that protect their business interests. Whether reviewing contracts, insurance procurement, or other commercial transactions, we provide proactive counsel designed to minimize exposure, reduce uncertainty, and support our clients' long-term business objectives.",
  },
];

export const ATTORNEYS = [
  {
    slug: "derek-newberry",
    firstName: "Derek",
    lastName: "Newberry",
    title: "Founding Partner",
    photo:
      "https://customer-assets-jai6qajn.emergentagent.net/job_newberry-wieters/artifacts/2kp7x8jn_LizDerekHeadshots-25.webp",
    email: "dnewberry@nwlawsc.com",
    phone: "843.998.7110",
    practiceAreas: [
      "Construction Litigation",
      "Mediation",
      "Personal Injury & Wrongful Death",
      "Professional Malpractice",
      "Corporate Counsel",
    ],
    bio: [
      "Derek is a founding partner of Newberry Wieters with a practice encompassing the full spectrum of construction defect, professional malpractice, product defect, personal injury, wrongful death, and property damage litigation. Having a knack for solving complex disputes, Derek is also a Certified Circuit Court Mediator with a quickly growing mediation practice.",
      "Before Newberry Wieters, Derek was a partner with a Southeastern based law firm with offices across the country and rose to co-chair its construction practice group. Over his career, Derek has routinely handled multi-million dollar disputes, and employs the lessons learned from those cases to help businesses manage risk on the front-end.",
      "Derek has received a number of professional recognitions, including: (1) the Rising Star and Super Lawyer designations by South Carolina's Super Lawyers magazine; (2) \"One to Watch\" by Best Lawyers\u00ae, a recognition given to young lawyers for professional excellence in private practice; (3) AV\u00ae Preeminent\u2122 Peer Review Rated by Martindale-Hubbell for his legal knowledge, communication skills, and ethical standards; and (4) \"Legal Elite\" by the Charleston Business Magazine.",
      "Derek attended Wofford College where he was a scholarship linebacker. He now lives on James Island with his wife Erin, three sons and two dogs. When he is not in the office, he is usually watching one of his boys play sports, boating, fishing, surfing or exploring the Charleston coast.",
    ],
    credentials: {
      admitted: [
        "South Carolina",
        "U.S. District Court for the District of South Carolina",
        "U.S. Court of Appeals for the Fourth Circuit",
      ],
      education: [
        "J.D., Charleston School of Law",
        "B.A., Wofford College",
      ],
      recognition: [
        "South Carolina Super Lawyers \u2014 Rising Star & Super Lawyer",
        "Best Lawyers\u00ae \u2014 Ones to Watch",
        "Martindale-Hubbell AV\u00ae Preeminent\u2122 Peer Review Rated",
        "Legal Elite \u2014 Charleston Business Magazine",
      ],
    },
  },
  {
    slug: "elizabeth-wieters",
    firstName: "Elizabeth",
    lastName: "Wieters",
    title: "Founding Partner",
    photo:
      "https://customer-assets-jai6qajn.emergentagent.net/job_newberry-wieters/artifacts/tkkyyhnn_LizDerekHeadshots-2.webp",
    email: "ewieters@nwlawsc.com",
    phone: "843.998.7110",
    practiceAreas: [
      "Insurance Coverage",
      "Bad Faith Insurance Litigation",
      "Construction Litigation",
      "Complex Commercial Disputes",
      "Corporate Counsel",
    ],
    bio: [
      "Elizabeth Wieters is a founding partner of Newberry Wieters, where her practice focuses on insurance coverage, coverage litigation, construction litigation, and complex commercial disputes. She advises clients on a wide range of insurance coverage issues across multiple lines of insurance and represents insurers and policyholders in coverage-related litigation, including declaratory judgment actions and other disputes in both state and federal courts.",
      "Drawing on over 15 years of experience in insurance and construction-related matters, Elizabeth counsels clients on first-party and third-party coverage issues involving property, commercial, and liability claims. Her work includes matters involving risk transfer, additional insured status, indemnity, allocation, defense obligations, and other complex coverage questions. She partners closely with clients to evaluate coverage positions, resolve disputes, and develop efficient strategies aligned with their objectives.",
      "Elizabeth also represents parties in construction and commercial litigation. She has tried cases to verdict, and her experience spans all phases of dispute resolution, from pre-suit negotiations and payment disputes through complex, multiparty litigation.",
      "She has practiced law in South Carolina's Lowcountry for over 15 years. Prior to entering private practice, Elizabeth served as a law clerk to the Honorable Steven H. John of the Fifteenth Judicial Circuit of South Carolina and as a judicial intern to the Honorable David C. Norton of the United States District Court for the District of South Carolina.",
      "Originally from Greenville, South Carolina, Elizabeth graduated from Greenville High School, earned her B.A. in Political Science from Sewanee, and her J.D. from the Charleston School of Law. Outside of the office, she enjoys exploring America\u2019s national parks with her family and walking on the beach with her golden retriever.",
    ],
    credentials: {
      admitted: [
        "South Carolina, 2009",
        "Fourth Circuit Court of Appeals",
        "U.S. District Court for the District of South Carolina",
        "U.S. Court of Appeals for the Fourth Circuit",
      ],
      education: [
        "J.D., Charleston School of Law, 2009",
        "B.A., Political Science, The University of the South (Sewanee), 2004",
      ],
      recognition: [
        "The Best Lawyers in America\u00ae, Best Lawyers\u00ae, 2024\u20132026 \u2014 Construction Law, Insurance Law, and Litigation \u2013 Insurance",
        "Legal Elite, Insurance Law \u2014 Charleston Business Magazine; 2020\u20132022, 2024",
      ],
    },
  },
  {
    slug: "anna-katherine-gregory",
    firstName: "Anna Katherine",
    lastName: "Gregory",
    title: "Associate",
    photo:
      "https://customer-assets-jai6qajn.emergentagent.net/job_newberry-wieters/artifacts/x3435dig_Screenshot%202026-09-21%20at%207.11.50%E2%80%AFAM.webp",
    email: "akgregory@nwlawsc.com",
    phone: "843.998.7110",
    practiceAreas: [
      "Construction Litigation",
      "Insurance Coverage",
      "Coverage Litigation",
      "Personal Injury",
      "Property Damage",
    ],
    bio: [
      "Anna Katherine Gregory is an associate at Newberry Wieters, where she focuses her practice on construction litigation, insurance coverage, coverage litigation, personal injury, and property damage litigation. She supports clients across a wide range of high-exposure litigation, bringing strong research, analytical, and advocacy skills to every case.",
      "Before Newberry Wieters, Anna Katherine gained valuable experience serving as an associate for a large law firm with a national footprint where she broadened her experience through litigating premises liability, construction defect, wrongful death, and general liability matters.",
      "Anna Katherine graduated summa cum laude from Charleston School of Law, where she ranked fifth in her class. While in law school, she earned multiple CALI Awards in core subjects and was actively involved in the Transactional Law Team, Business Law Society, and served as an Ambassador and a Contracts I & II Fellow. Before pursuing her legal education, Anna Katherine received her B.S. in Genetics with a minor in Spanish from the University of Georgia.",
    ],
    credentials: {
      education: [
        "J.D., summa cum laude, Charleston School of Law (5th in class)",
        "B.S., Genetics with a minor in Spanish, University of Georgia",
      ],
      recognition: [
        "Summa Cum Laude \u2014 Charleston School of Law",
        "Multiple CALI Awards \u2014 Core Subjects",
        "Transactional Law Team; Business Law Society",
        "Contracts I & II Fellow; Student Ambassador",
      ],
    },
  },
];

export const STAFF = [
  {
    slug: "bonnie-ellenberger",
    firstName: "Bonnie",
    lastName: "Ellenberger",
    title: "Paralegal & Office Manager",
    photo:
      "https://customer-assets-jai6qajn.emergentagent.net/job_newberry-wieters/artifacts/53qk08t1_Screenshot%202026-09-21%20at%207.06.56%E2%80%AFAM.webp",
    email: "bellenberger@nwlawsc.com",
    phone: "843.998.7110",
    focus: [
      "Firm Operations",
      "Paralegal Support",
      "Litigation Coordination",
      "Client Service",
    ],
    bio: [
      "Drawing on more than fifteen years of experience in the legal field, Bonnie Ellenberger plays an integral role at Newberry Wieters, where she oversees firm operations and provides paralegal support to the firm\u2019s attorneys and clients. She brings a valuable combination of litigation experience, team leadership, and law firm management to the practice.",
      "Before joining Newberry Wieters, Bonnie spent years working at large, multistate law firms, where she supported busy litigation teams of multiple partners and associates. Over the course of her career, Bonnie took on increasing leadership and administrative responsibilities. In addition to managing the demands of a sophisticated litigation practice, she coordinated team workflows, interviewed, trained, and mentored new hires, and became a trusted resource for attorneys and staff alike.",
      "Known for her intuition, dependability, and ability to solve problems, Bonnie has a talent for anticipating what needs to be done and making sure it gets done. At Newberry Wieters, she draws on that experience to keep the firm\u2019s operations running efficiently while providing experienced, hands-on support to its clients.",
      "A true Gamecock, Bonnie graduated from the University of South Carolina. Outside the office, she enjoys fossil hunting, cheering on the Gamecock women\u2019s basketball team, spending time with friends, and enjoying live music around Charleston with her family.",
    ],
    education: ["B.A., University of South Carolina"],
  },
];
